import { Button, MenuItem } from '@mui/material';
import { useForm } from 'react-hook-form';
import InputField from '../../components/InputField';

interface AddCandidate {
  employeeName: string;
  gender: string;
  dateOfJoining: Date;
  mobileNumber: string;
  emailId: string;
  designation: string;
  employeeID: string;
  emergencycontactNumber: string;
}
const IDCardPage = () => {
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm<AddCandidate>();

  const onSubmit = handleSubmit(async () => {
    // TODO: Implement
  });

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className="font-bold bg-white italic hover:italic pt-5 text-2xl underline hover:underline-offset-4">
        Add Candidate Details:
      </div>

      <div className="flex justify-end"></div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pt-3">
        <InputField
          id="Employee Name"
          label="Employee Name"
          {...register('employeeName', {
            required: true,
          })}
          required
          error={!!errors.employeeName}
          placeholder="Enter employeeName"
        />
        <InputField
          id="gender"
          label="Gender"
          select
          {...register('gender')}
          error={!!errors.gender}
        >
          {['Male', 'Female'].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </InputField>
        <InputField
          id="dateOfJoining"
          {...register('dateOfJoining', { required: true })}
          label="Date Of Joining"
          required
          defaultValue={new Date().toISOString().slice(0, 10)}
          type="date"
        />
        <InputField
          id="mobileNumber"
          label="Mobile Number"
          {...register('mobileNumber', {
            required: true,
          })}
          required
          error={!!errors.mobileNumber}
          placeholder="Enter mobileNumber"
        />
        <InputField
          id="emergencycontactNumber"
          label=" Emergency Contact Number"
          {...register('emergencycontactNumber', {
            required: true,
          })}
          required
          error={!!errors.emergencycontactNumber}
          placeholder="Enter emergencycontactNumber"
        />
        <InputField
          id="emailId"
          label="Email Id"
          {...register('emailId', {
            required: true,
          })}
          required
          error={!!errors.emailId}
          placeholder="Enter emailId"
        />

        <InputField
          id="designation"
          label="Designation"
          {...register('designation', {
            required: true,
          })}
          required
          error={!!errors.designation}
          placeholder="Enter designation"
        />
        <InputField
          id="employeeID"
          label="Employee ID"
          {...register('employeeID', {
            required: true,
          })}
          required
          error={!!errors.employeeID}
          placeholder="Enter employeeID"
        />
      </div>

      <div className="flex justify-center mt-10">
        <Button type="submit" variant="contained" className="w-40">
          SAVE
        </Button>
      </div>
    </form>
  );
};

export default IDCardPage;
